import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { RootCmp } from './routes/routes'
import './assets/styles/main.scss'
import './components/language/i18next'
import { Provider } from "react-redux"
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './store/store'
import ReactGA from "react-ga4";
import { GoogleOAuthProvider } from '@react-oauth/google'

function once(eventTarget, eventName, timeoutMs = 2000) {
  return new Promise((resolve) => {
    let done = false;
    const on = () => { if (!done) { done = true; eventTarget.removeEventListener(eventName, on); resolve(true); } };
    eventTarget.addEventListener(eventName, on, { once: true });
    setTimeout(() => { if (!done) { done = true; eventTarget.removeEventListener(eventName, on); resolve(false); } }, timeoutMs);
  });
}

function delay(ms) {
  return new Promise(res => setTimeout(res, ms));
}

function hidePreloader() {
  const el = document.getElementById('preload-root');

  if (typeof window.__UPSPLASH_STOP__ === 'function') {
    window.__UPSPLASH_STOP__();
    window.__UPSPLASH_STOP__ = null;
  }

  if (!el) return;

  el.classList.add('fade-out');

  setTimeout(() => {
    el.remove();
  }, 400);
}
ReactGA.initialize(process.env.REACT_APP_GA_ID); // seu Measurement ID
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <Provider store={store}>
      <PersistGate
        loading={null}
        persistor={persistor}
        onBeforeLift={async () => {
          try {
            const state = store.getState();

            const navType =
              state?.auth?.currentUser?.thema ||
              state?.customization?.navType;

            if (navType === 'dark' || navType === 'light') {
              localStorage.setItem('upsuite_theme', navType);
            }

            await Promise.all([
              once(document, 'upsuite:splash-ready', 800),
              delay(500)
            ]);
          } finally {
            hidePreloader();
          }
        }}
      >
        <Router>
          <RootCmp />
        </Router>
      </PersistGate>
    </Provider>
  </GoogleOAuthProvider>
);
